import axios from 'axios';

var getRoles = function getRoles() {
  return axios.get('roles');
};

export { getRoles };